import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-enrollment-closed',
  imports: [MatIconModule],
  templateUrl: './enrollment-closed.component.html',
  styleUrl: './enrollment-closed.component.scss'
})
export class EnrollmentClosedComponent {

}
